import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Card from '@/components/common/Card';
import devicesIcon from '@/components/common/icons/devices.svg';
import cogIcon from '@/components/common/icons/cog.svg';
import editImage from '@/components/common/icons/edit.svg';
import classes from '@/components/InspectorsPage/InspectorDetails/style.module.scss';

const InspectorAppSettingsView = ({ appSettingsData, inspectorId, isEditable, intl }) => {
  const settings = appSettingsData?.settings || {};
  const copilotDependencyAvailable = appSettingsData?.copilot_dependency_available ?? false;
  const appVersion = appSettingsData?.app_version;

  const getSyncModeText = (mode) => {
    switch (mode) {
      case 0:
        return intl.formatMessage({ id: 'SYNC_FILES_ALWAYS' });
      case 1:
        return intl.formatMessage({ id: 'SYNC_FILES_FINISHED_ONLY' });
      case 2:
        return intl.formatMessage({ id: 'SYNC_FILES_WIFI_ONLY' });
      default:
        return '-----';
    }
  };

  const getDetailsOrderText = (order) => {
    switch (order) {
      case 0:
        return intl.formatMessage({ id: 'DETAILS_ORDER_ALPHABETIC' });
      case 1:
        return intl.formatMessage({ id: 'DETAILS_ORDER_MOST_USED' });
      default:
        return '-----';
    }
  };

  const getBooleanText = (val) => {
    if (val === true) return intl.formatMessage({ id: 'ENABLED' });
    if (val === false) return intl.formatMessage({ id: 'DISABLED' });
    return '-----';
  };

  return (
    <Card className="fade-in">
      <h2 className={classes.cardHeadWithLink}>
        <div>
          <div className={classes.icon}>
            <img src={devicesIcon} alt={intl.formatMessage({ id: 'APP_SETTINGS' })} />
          </div>
          {intl.formatMessage({ id: 'APP_SETTINGS' })}
        </div>
        {isEditable && inspectorId && (
          <Link
            to={`/inspectors/active/${inspectorId}/app-settings/edit`}
            title={intl.formatMessage({ id: 'EDIT' })}
            data-tip={intl.formatMessage({ id: 'EDIT' })}
          >
            <img src={editImage} alt={intl.formatMessage({ id: 'EDIT' })} />
          </Link>
        )}
      </h2>

      <h3 className={classes.subtitle}>
        <div className={classes.icon}>
          <img src={cogIcon} alt={intl.formatMessage({ id: 'APP_SETTINGS_CONFIG' })} />
        </div>
        {intl.formatMessage({ id: 'APP_SETTINGS_CONFIG' })}
      </h3>

      <div className={`${classes.field} ${classes.isFlex}`}>
        <div className={`${classes.field} ${classes.is6}`}>
          <p className={classes.label}>{intl.formatMessage({ id: 'SYNC_FILES' })}</p>
          <p className={classes.value}>{getSyncModeText(settings.sync_mode)}</p>
        </div>
        <div className={`${classes.field} ${classes.is6}`}>
          <p className={classes.label}>{intl.formatMessage({ id: 'DETAILS_DISPLAY_ORDER' })}</p>
          <p className={classes.value}>{getDetailsOrderText(settings.details_order)}</p>
        </div>
      </div>

      <div className={`${classes.field} ${classes.isFlex}`}>
        <div className={`${classes.field} ${classes.is6}`}>
          <p className={classes.label}>{intl.formatMessage({ id: 'COPILOT_RV_ENABLED' })}</p>
          <p className={classes.value}>{getBooleanText(settings.copilot_enabled)}</p>
        </div>
        {copilotDependencyAvailable && (
          <div className={`${classes.field} ${classes.is6}`}>
            <p className={classes.label}>{intl.formatMessage({ id: 'COPILOT_RV_DEPENDENCY' })}</p>
            <p className={classes.value}>
              {getBooleanText(settings.dependency_auto_copilot ?? settings.copilot_dependency_enabled)}
            </p>
          </div>
        )}
      </div>

      <div className={classes.field}>
        <p className={classes.label}>{intl.formatMessage({ id: 'APP_VERSION' })}</p>
        <p className={classes.value}>{appVersion || '-----'}</p>
      </div>
    </Card>
  );
};

InspectorAppSettingsView.propTypes = {
  appSettingsData: PropTypes.object,
  inspectorId: PropTypes.string,
  isEditable: PropTypes.bool,
  intl: PropTypes.object.isRequired,
};

InspectorAppSettingsView.defaultProps = {
  appSettingsData: null,
  inspectorId: null,
  isEditable: true,
};

export default InspectorAppSettingsView;
